import styled from "styled-components";
import { BreakPoints, FontWeights } from "../../constants";
import { typographyMixin } from "../../typography";

export const StyledTeamStatsContainer = styled.div`
  width: 100%;
  padding: 1rem 0rem 0 0;
  ${typographyMixin}

  .title-divider {
    padding: 0 1rem 0 0;
    font-weight: ${FontWeights.bold};

    @media only screen and (max-width: ${BreakPoints.md}) {
      padding: 0 0rem;
    }
  }
`;

export const StyledTeamsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 0 0.5rem 0 0;
  @media only screen and (max-width: ${BreakPoints.sm}) {
    padding: 0 0rem;
  }
`;

export const StyledTeamNameAndLogoContainer = styled.div`
  display: flex;
  align-items: center;
  font-size: 18px;
  font-style: normal;
  font-weight: ${FontWeights.bold};
  padding: 1rem 0;
  max-width: 50%;

  .team-logo-container {
    padding: 0 0.5rem;
  }

  .home-title {
    text-align: right;
  }

  .visitor-title {
    text-align: left;
  }
  @media only screen and (max-width: ${BreakPoints.md}) {
    font-size: 14px;
  }

  @media only screen and (max-width: ${BreakPoints.sm}) {
    font-size: 14px;
    line-height: 17px;
    display: flex;
    text-transform: uppercase;
    justify-content: center;
    flex-direction: row;
    .team-logo-container {
      display: none;
    }
  }
`;

export const StyledStats = styled.div`
  padding: 0 0.5rem 0 0;

  @media only screen and (max-width: ${BreakPoints.sm}) {
    padding: 0 0rem;
  }

  width: 100%;
`;

export const StyledStat = styled.div`
  &:nth-child(even) {
    background-color: rgba(55, 56, 61, 0.05);
  }

  ${typographyMixin}

  min-height: 50px;

  .title {
    font-size: 14px;
    text-align: center;
    font-weight: ${FontWeights.bold};
  }
`;

export const StyledStatBarNumberContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  .stat-value {
    flex-basis: 5rem;
    padding: 0 1.25rem;
    font-weight: ${FontWeights.bold};

    @media only screen and (max-width: ${BreakPoints.sm}) {
      flex-basis: 1rem;
      padding: 0 0.5rem;
    }
  }
`;

export const StyledBar = styled.div<{ visitorBarLength: string; homeBarLength: string }>`
  width: 85%;
  height: 8px;
  display: flex;

  .visitor-bar {
    width: ${(p) => p.visitorBarLength};
    height: 100%;
    background-color: ${(p) => p.theme.primaryColor};
    border-radius: 30px;
    border-bottom-right-radius: 0px;
    border-top-right-radius: 0px;
  }

  .home-bar {
    width: ${(p) => p.homeBarLength};
    height: 100%;
    background-color: ${(p) => p.theme.secondaryColor};
    border-radius: 30px;
    border-bottom-left-radius: 0px;
    border-top-left-radius: 0px;
  }

  @media only screen and (max-width: ${BreakPoints.sm}) {
    width: 70%;
  }
`;

export const NoStats = styled.div`
  text-align: center;
  padding: 1rem 0rem;
  font-weight: ${FontWeights.regular};
  font-size: 18px;
  font-style: light;
`;
